// extracted by mini-css-extract-plugin
export default {"container":"M4_Ejercicio8_container__jgGTE","input":"M4_Ejercicio8_input__6zEUi","canvas":"M4_Ejercicio8_canvas__75o5N","btn":"M4_Ejercicio8_btn__dxYvY"};